import {
  /**Register Esignature external*/
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  REGISTER,
  REGISTER_CLEAR_DATA,
  /**Login Esignature external */
  LOGIN,
  LOGIN_CLEAR_DATA,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  FORGET_PASSWORD,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  HASH_VALIDATE,
  HASH_VALIDATE_SUCCESS,
  HASH_VALIDATE_ERROR,
} from "./actionType";

const initialState = {
  /**create user */
  errorRegister: null,
  responseRegister: null,
  loadingRegister: false,
  /**END */

  /* Page login
  list API's*/
  errorLogin: null,
  responseLogin: null,
  loadingLogin: false,
  /* Page login
    END*/

  //forget my password
  errorForgetPassword: null,
  responseForgetPassword: null,
  loadingForgetPassword: false,
  //reset password
  errorResetPassword: null,
  responseResetPassword: null,
  loadingResetPassword: false,
  //Hash Validate
  errorHashValidate: null,
  responseHashValidate: null,
  loadingHashValidate: false,
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    /**Create user login  */
    case REGISTER:
      state = {
        ...state,
        errorRegister: null,
        loadingRegister: true,
      };
      break;
    case REGISTER_SUCCESS:
      state = {
        ...state,
        errorRegister: null,
        responseRegister: action.payload,
        loadingRegister: false,
      };
      break;
    case REGISTER_ERROR:
      state = {
        ...state,
        errorRegister: action.payload,
        responseRegister: null,
        loadingRegister: false,
      };
      break;
    case REGISTER_CLEAR_DATA:
      state = {
        ...state,
        errorRegister: null,
        responseRegister: null,
        loadingRegister: false,
      };
      break;
    /**end */
    /* Page login
  list API's*/
    case LOGIN:
      state = {
        ...state,
        errorLogin: null,
        loadingLogin: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        errorLogin: null,
        responseLogin: action.payload,
        loadingLogin: false,
      };
      break;
    case LOGIN_ERROR:
      state = {
        ...state,
        errorLogin: action.payload,
        responseLogin: null,
        loadingLogin: false,
      };
      break;
    case LOGIN_CLEAR_DATA:
      state = {
        ...state,
        errorLogin: null,
        responseLogin: null,
        loadingLogin: false,
      };
      break;
    case FORGET_PASSWORD: //forget password
      state = {
        ...state,
        errorForgetPassword: null,
        loadingForgetPassword: true,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        errorForgetPassword: null,
        responseForgetPassword: action.payload,
        loadingForgetPassword: false,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = {
        ...state,
        errorForgetPassword: action.payload,
        loadingForgetPassword: false,
        responseForgetPassword: null,
      };
      break;
    case RESET_PASSWORD: //RESET PASSWORD
      state = {
        ...state,
        errorResetPassword: null,
        loadingResetPassword: true,
      };
      break;
    case RESET_PASSWORD_SUCCESS:
      state = {
        ...state,
        errorResetPassword: null,
        responseResetPassword: action.payload,
        loadingResetPassword: false,
      };
      break;
    case RESET_PASSWORD_ERROR:
      state = {
        ...state,
        errorResetPassword: action.payload,
        loadingResetPassword: false,
        responseResetPassword: null,
      };
      break;
    case HASH_VALIDATE: //HASH_VALIDATE
      state = {
        ...state,
        errorHashValidate: null,
        loadingHashValidate: true,
      };
      break;
    case HASH_VALIDATE_SUCCESS:
      state = {
        ...state,
        errorHashValidate: null,
        responseHashValidate: action.payload,
        loadingHashValidate: false,
      };
      break;
    case HASH_VALIDATE_ERROR:
      state = {
        ...state,
        errorHashValidate: action.payload,
        loadingHashValidate: false,
        responseHashValidate: null,
      };
      break;
    /* Page login
        END*/
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default auth;
